<template>
  <div class="user-profile-card bg-white shadow-sm">
    <div class="text-center">
      <received-kudos class="user-profile-card-icon" />
      <h3 class="mt-4 mb-4">A skill I can offer</h3>
      <div v-if="editable" class="user-profile-card-edit">
        <b-button variant="link" class="btn-link-edit-gray" size="lg" @click.prevent="$emit('edit')">
          <edit-pen-icon :style="{fontSize: '1.5rem'}" />
        </b-button>
      </div>
    </div>
    <div>
      <b-badge v-for="skill in toArray" :key="skill" pill class="badge-skill m-2">
        {{skill}}
      </b-badge>
    </div>
  </div>
</template>

<script>
import ReceivedKudos from '@/assets/images/green/received-kudos.svg'
import EditPenIcon from '@/assets/images/edit-pen.svg'

export default {
  name: 'Skills',

  props: {
    skills: {
      type: String
    },

    editable: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    toArray() {
      return (this.skills || '').split(',').map(p => p.trim()).filter(Boolean)
    }
  },

  components: {
    ReceivedKudos,
    EditPenIcon
  }
}
</script>
